import React from "react";
import Header from "./Components/Header";
import Main from "./Components/Main";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header></Header>
      <Main></Main>
      <footer>
        <div>Developed with ❤️</div>
        <div>
          <a href="http://github.com/aedit">
            <img width="20px" src="/github.svg" /> aedit
          </a>
          &nbsp;&amp;&nbsp;
          <a href="http://github.com/vbhv98">
            <img width="20px" src="/github.svg" /> vbhv98
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
